/* eslint-disable react/jsx-props-no-spreading */
import { FieldErrors, FieldValues, FormProvider, useForm, useFormContext } from "react-hook-form";
import InputFieldWithLabel from "components/molecules/forms/InputFieldWithLabel";
import PollSelectElement from "components/organisms/poll/PollSelectElement";
import { email_regex } from "constants/constants";
import Button from "../buttons/Button";
import Modal from "../modal";
import { CloseIcon } from "../Icon";

function DynamicControl({
  inputType,
  label,
  fieldName,
  defaultValue,
  options = [],
  config,
  additionalClasses,
  labelClasses,
}: DynamicFormField) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  switch (inputType) {
    case "text":
    case "number":
      return (
        <InputFieldWithLabel
          labelClasses={labelClasses}
          additionalClasses={additionalClasses}
          type={inputType}
          label={label}
          id={fieldName}
          register={register}
          placeHolder={defaultValue}
          defaultValue={defaultValue}
          errorMessage={errors[fieldName]?.message as any}
          isRequired={config?.required}
        />
      );
    // <input type="text" {...register(fieldName, config)} defaultValue={defaultValue} />;
    case "select": {
      return (
        <PollSelectElement
          labelClasses={labelClasses}
          additionalClasses={additionalClasses}
          label={label}
          options={options}
          id={fieldName}
          register={register}
          errorMessage={errors[fieldName]?.message as any}
          isRequired
        />
      );
    }

    default:
      return null;
  }
}

export default function DynamicForm({
  isCustomizedUIBrand = false,
  fields,
  onClose,
  isOpen = true,
  handleFormSubmit,
}: {
  fields: DynamicFormField[];
  onClose: any;
  isOpen?: boolean;
  handleFormSubmit: (userResponse: Object) => Promise<void>;
  isCustomizedUIBrand?: boolean;
}) {
  const formMethods = useForm();

  const { handleSubmit, setError } = formMethods;

  function onSubmit(data: any) {
    if (data.email && !email_regex.test(data.email)) {
      setError("email", {
        type: "manual",
        message: "Invalid email",
      });
      return;
    }
    handleFormSubmit(data);
  }

  function onError(error: FieldErrors<FieldValues>) {
    if (Object.keys(error).length === 0) return;
    // Loop over the error keys and set error message for required fields.
    Object.keys(error).forEach((key) => {
      if (error[key]?.type === "required") {
        setError(key, {
          type: "manual",
          message: `${key} is required`,
        });
      }
    });
  }

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div
        className={`relative my-8  w-[95vw] max-w-[480px] space-y-6 rounded-2xl ${
          isCustomizedUIBrand ? "bg-[#e7e6e7] text-primary" : "bg-primary text-white"
        } p-5 shadow-modal sm:p-5`}
      >
        <div className="flex justify-between">
          <section className=" w-[90%] font-sora text-xl font-semibold xl:text-2xl">
            {isCustomizedUIBrand ? "Enroll" : "Claim"}
          </section>
          <span onClick={onClose} className="my-auto cursor-pointer">
            <CloseIcon className="h-5 w-5" />
          </span>
        </div>
        <form onSubmit={(e) => e.preventDefault()}>
          <FormProvider {...formMethods}>
            {fields.map((d) => (
              <div key={d.fieldName}>
                <DynamicControl
                  {...d}
                  additionalClasses={isCustomizedUIBrand ? "!text-primary !border-[#842572]" : ""}
                  labelClasses={isCustomizedUIBrand ? "!text-primary" : ""}
                />
              </div>
            ))}
          </FormProvider>
          <div className="mt-2 flex justify-end">
            <Button
              text="SUBMIT"
              onClick={handleSubmit(onSubmit, onError)}
              variant="rustPinkSolid"
              type="submit"
              additionalClasses={isCustomizedUIBrand ? "!bg-[#842572] !text-white" : ""}
            />
          </div>
        </form>
      </div>
    </Modal>
  );
}
